import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=12fd45e9&scoped=true&"
import script from "./Tiers.vue?vue&type=script&lang=js&"
export * from "./Tiers.vue?vue&type=script&lang=js&"
import style0 from "./Tiers.vue?vue&type=style&index=0&id=12fd45e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd45e9",
  null
  
)

export default component.exports